import { z } from "zod/v4";

import { AgencyDtoSchema, FullAgencyDtoSchema } from "../../../dtos/agencies";

export const GetFullAgencyByIdRequestPathParamSchema = z.object({
  agencyId: z.uuid(),
});
export type GetFullAgencyByIdRequestPathParamType = z.infer<
  typeof GetFullAgencyByIdRequestPathParamSchema
>;
export const GetFullAgencyByIdResponseBodySchema = z.object({
  agency: FullAgencyDtoSchema,
});

export type GetFullAgencyByIdResponseBodyType = z.infer<
  typeof GetFullAgencyByIdResponseBodySchema
>;
